export default "__VITE_ASSET__2c6a0108__"